<template>
  <div class="v-userInfo">
      <DetailHead />
      <section class="userInfo-section">
          <h4>基础信息</h4>
          <ul class="userInfo-list">
            <li>
              <span>姓名</span>
              <div v-text="dt_userInfo.nickName"></div>
            </li>
            <li>
              <span>头像</span>
              <div>
                <img :src="dt_userInfo.avatar"  />
              </div>
            </li>
            <li>
              <span>手机号</span>
              <div v-text="dt_userInfo.mobile || '立即绑定'" @click="fn_showBindPhone" :class="cp_notBindPhone ? 'selectColor' : ''"></div>
            </li>
            <li>
              <span>橙光账号</span>
              <div @click="fn_toggleBindOrg(true)" :class="!dt_hasBindOrg ? 'selectColor' : ''">
                {{dt_hasBindOrg == null ? '' : (dt_hasBindOrg ? (dt_orgNickname || '已绑定') : '立即绑定')}}
              </div>
            </li>
            <li>
              <span >用户ID</span>
              <div v-text="dt_userInfo.uid"></div>
            </li>
            <li>
              <span >创建日期</span>
              <div v-text="dt_userInfo.createTime"></div>
            </li>
          </ul>
      </section>
      <td-bind-mobile  v-if="dt_isBindPhone" @bind_succeed="fn_bindPhoneSuccess" @bind_merge="fn_mergeAccount" :visible.sync="dt_isBindPhone"  pr_type="mx"></td-bind-mobile>
      <TheLogin v-if="dt_visibleBindOrg" :isNewBind="true" @login="fn_bindOrgAccount" @close="dt_visibleBindOrg = false" />
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import { mapState } from 'vuex'
import TdBindMobile from './components/TdBindMobile'
import DetailHead from '../detail/components/DetailHead'
import TheLogin from '@/components/TheLogin'
import { axiosCheckPublishProjectPermission } from '@/service/api.js'
import { areaCodeList } from '@/constants'

export default {
    components: {
        TdBindMobile,
        DetailHead,
        TheLogin
    },
    data() {
      return {
          dt_userInfo: {
            // 用户名称
            nickName: "木夕阅读",
            // 用户头像
            avatar: "",
            // 手机号
            mobile: "",
            // 用户id
            uid: 0,
            // 创建日期
            createTime: 2019
          },
          dt_isBindPhone: false,
          dt_hasBindOrg: null,  // 只有初始时才为null，之后只为true/false
          dt_visibleBindOrg: false,
          dt_orgNickname: '',
          areaCodeList,
      }
    },
    computed:{
      ...mapState([
        // 'vx_bindInfo',
        'vx_userInfo',
        'vx_isShowLogin'
      ]),
      ...mapState({
        // vx_get_bindInfo: state => state.vx_bindInfo,
        vx_get_userInfo: state => state.vx_userInfo
      }),
      cp_notBindPhone() { 
        return !this.vx_get_userInfo.isBindMoblie && !this.vx_get_userInfo.mobile;
      }
    },
    watch: {
      async vx_userInfo() {
        if (!this.vx_userInfo.isMxPublish) {
          await this.xhr_axiosCheckPublishProjectPermission();
        }
        this.init();
      }
    },
    async created() {
      if (this.vx_userInfo && !this.vx_userInfo.isMxPublish) {
        await this.xhr_axiosCheckPublishProjectPermission();
      }
      this.init();
    },
    methods: {
      init() {
        this.fn_fetchBindInfo()
        let {vx_get_userInfo} =  this;
        vx_get_userInfo  = vx_get_userInfo || {};
        this.dt_userInfo.nickName = vx_get_userInfo.nickName;
        let url =  vx_get_userInfo.avatar;
        url =  url && url.indexOf('http') == 0 ? url : 'http://mxcdn.muccyapi.com/' + url
        this.dt_userInfo.avatar =  url || '未设置';
        this.dt_userInfo.mobile =  vx_get_userInfo.mobile;
        this.dt_userInfo.uid = vx_get_userInfo.uid || 0;
        this.dt_userInfo.createTime = vx_get_userInfo.createTime ?  this.ut_formatTime('Y-m-d', vx_get_userInfo.createTime) : '0';
      },
      fn_fetchBindInfo() {
        this.$api.axiosGetBindInfo().then(res => {
          if (res.isOk) {
            res.data = res.data || []
            // this.vx_setData({ vx_bindInfo: res.data })
            let orgData = res.data.find(d => d.bindType == 4)
            this.dt_hasBindOrg = orgData ? true : false
            if (this.dt_hasBindOrg) this.fn_bindOrgSuccess()
            // 从绑定信息接口中获取到绑定手机号后，再次设置一下，以防万一（不再用findOne接口中取得的用户信息里的手机号了）
            let phoneData = res.data.find(d => d.bindType == 0)
            let phoneVal = phoneData ? phoneData.bindValue : ''
            this.vx_get_userInfo.mobile = phoneVal;
            this.dt_userInfo.mobile = phoneVal;
          } else {
            this.$message.error(res.msg || '获取账户绑定信息失败')
          }
        })
      },
      fn_bindOrgSuccess() {
        this.fn_toggleBindOrg(false)
        this.dt_orgNickname = ''  // 防止在当页切换账号再绑定橙光时，会先显示一下上个账号的橙光昵称
        this.dt_hasBindOrg = true
        this.$api.axiosGetCgName().then(res => {
          if (res.isOk) {
            this.dt_orgNickname = res.data.uname || ''
          }
        })
      },
      fn_toggleBindOrg(v = !this.dt_visibleBindOrg) {
        if (this.dt_hasBindOrg) return;
        this.dt_visibleBindOrg = v
      },
      fn_bindOrgAccount(resOrg) {
        let { status, data } = resOrg
        if (!status) {
          this.fn_toggleBindOrg(false)
          return
        }
        this.$api.axiosBindV3({
          platformType: 4,
          platformValue: data.uid,
          userPlatFromJs: data
        }).then(res => {
          if (res.isOk) {
            this.$message.success('绑定橙光账号成功')
            this.fn_bindOrgSuccess()
          } else if (res.code == 500019) {
            this.fn_mergeAccount(data.uid)
          } else {
            this.$message.error(res.msg || '绑定橙光账号失败')
          }
        }).catch(e => {
          console.error('绑定橙光账号失败', e)
          this.$message.error('网络连接失败')
        })
      },
      async fn_mergeAccount(value, type = 4, password, typeCode) {
        let accountType = {
          0: '手机号',
          4: '橙光账号'
        }[type]
        let successCb = () => {
          if (type == 4) {
            this.fn_bindOrgSuccess()
          } else if (type == 0) {
            this.fn_bindPhoneSuccess(value)
            this.dt_isBindPhone = false
          }
        }
        try {
          await MessageBox.confirm(`该号码已被注册，是否将该账号内容合并到当前账号？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          })
        } catch (e) {
          console.warn(e)
          if (type == 4) this.fn_toggleBindOrg(false)
          return
        }
        this.$api.axiosMergeAccount({
          platformType: type,
          platformValue: value,
          password, // PS: 只有绑定手机号时才需要设置密码
          typeCode, // PS: 只有绑定手机号时才需要设置国际区号
        }).then(res => {
          if (res.isOk) {
            this.$message.success(`绑定${accountType}成功`)
            successCb()
          } else {
            this.$message.error(res.msg || `绑定${accountType}失败`)
          }
        }).catch(e => {
          console.error('合并账号失败', e)
          this.$message.error('网络连接失败')
        })
      },
      fn_showBindPhone() {
        if (!this.cp_notBindPhone) return;
        this.dt_isBindPhone = true
      },
      // 绑定成功手机号回调
      fn_bindPhoneSuccess(mobile) {
        this.vx_get_userInfo.isBindMoblie = true;
        this.vx_get_userInfo.isMxPublish = 2;
        this.vx_get_userInfo.mobile = mobile;
        this.dt_userInfo.mobile = mobile; // "已绑定"
      },
      /** 
       * 时间戳格式化函数 
       * @param {string} format 格式 
       * @param {int} timestamp 要格式化的时间 默认为当前时间 
       * @return {string}   格式化的时间字符串 
       */
      ut_formatTime(format, timestamp){ 
          let jsdate=((timestamp) ? new Date(timestamp) : new Date()); 
          let pad = function(n, c){ 
            if((n = n + "").length < c){ 
            return new Array(++c - n.length).join("0") + n; 
            } else { 
            return n; 
            } 
          }; 
          let txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; 
          let txt_ordin = {1:"st", 2:"nd", 3:"rd", 21:"st", 22:"nd", 23:"rd", 31:"st"}; 
          let txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; 
          let f = { 
            // Day 
            d: function(){return pad(f.j(), 2)}, 
            D: function(){return f.l().substr(0,3)}, 
            j: function(){return jsdate.getDate()}, 
            l: function(){return txt_weekdays[f.w()]}, 
            N: function(){return f.w() + 1}, 
            S: function(){return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'}, 
            w: function(){return jsdate.getDay()}, 
            z: function(){return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0}, 
            
            // Week 
            W: function(){ 
            let a = f.z(), b = 364 + f.L() - a; 
            let nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1; 
            if(b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b){ 
              return 1; 
            } else{ 
              if(a <= 2 && nd >= 4 && a >= (6 - nd)){ 
              nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31"); 
              return this.ut_formatTime("W", Math.round(nd2.getTime()/1000)); 
              } else{ 
              return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0); 
              } 
            } 
            }, 
            
            // Month 
            F: function(){return txt_months[f.n()]}, 
            m: function(){return pad(f.n(), 2)}, 
            M: function(){return f.F().substr(0,3)}, 
            n: function(){return jsdate.getMonth() + 1}, 
            t: function(){ 
            let n; 
            if( (n = jsdate.getMonth() + 1) == 2 ){ 
              return 28 + f.L(); 
            } else{ 
              if( n & 1 && n < 8 || !(n & 1) && n > 7 ){ 
              return 31; 
              } else{ 
              return 30; 
              } 
            } 
            }, 
            
            // Year 
            L: function(){let y = f.Y();return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0}, 
            //o not supported yet 
            Y: function(){return jsdate.getFullYear()}, 
            y: function(){return (jsdate.getFullYear() + "").slice(2)}, 
            
            // Time 
            a: function(){return jsdate.getHours() > 11 ? "pm" : "am"}, 
            A: function(){return f.a().toUpperCase()}, 
            B: function(){ 
            // peter paul koch: 
            let off = (jsdate.getTimezoneOffset() + 60)*60; 
            let theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off; 
            let beat = Math.floor(theSeconds/86.4); 
            if (beat > 1000) beat -= 1000; 
            if (beat < 0) beat += 1000; 
            if ((String(beat)).length == 1) beat = "00"+beat; 
            if ((String(beat)).length == 2) beat = "0"+beat; 
            return beat; 
            }, 
            g: function(){return jsdate.getHours() % 12 || 12}, 
            G: function(){return jsdate.getHours()}, 
            h: function(){return pad(f.g(), 2)}, 
            H: function(){return pad(jsdate.getHours(), 2)}, 
            i: function(){return pad(jsdate.getMinutes(), 2)}, 
            s: function(){return pad(jsdate.getSeconds(), 2)}, 
            //u not supported yet 
            
            // Timezone 
            //e not supported yet 
            //I not supported yet 
            O: function(){ 
            let t = pad(Math.abs(jsdate.getTimezoneOffset()/60*100), 4); 
            if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t; 
            return t; 
            }, 
            P: function(){let O = f.O();return (O.substr(0, 3) + ":" + O.substr(3, 2))}, 
            //T not supported yet 
            //Z not supported yet 
            
            // Full Date/Time 
            c: function(){return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()}, 
            //r not supported yet 
            U: function(){return Math.round(jsdate.getTime()/1000)} 
          };
          let ret = "";
          return format.replace(/([a-zA-Z])/g, (t, s)=> { 
            
            if( t != s ){ 
            ret = s; 
            } else if( f[s] ){ 
            ret = f[s](); 
            } else{ 
            ret = s; 
            } 
            return ret; 
          }); 
      },

      async xhr_axiosCheckPublishProjectPermission() {
        let  {data, isOk} = await axiosCheckPublishProjectPermission();
        if (isOk && data) {
          this.vx_userInfo.isMxPublish = data.mobile ? 2 : 1;
        } else {
          this.vx_userInfo.isMxPublish = 1;
        }
      }
    }
}
</script>

<style scoped lang="less">
  .v-userInfo{
    display: flex;
    flex-direction: column;
  }
  .userInfo-section {
      margin:0 auto;
      width:1200px;
      // box-shadow: 10px -4px 5px rgba(0,0,0,0.2);
      flex:1;
      padding:45px 0 45px 10px;
      background-color:#fff;
      box-sizing: border-box;
      h4 {
        font-size:16px;
        color:#bebebe;
        margin-bottom:20px;
        padding-bottom: 30px;
        border-bottom: 1px solid #ebeef5;
      }
  }
  .userInfo-list {
    width:100%;
    li {
        font-size:16px;
        display: flex;
        padding:10px 0;
        overflow: hidden;
        span,div{
          line-height:42px;
          display: inline-block;
        }
        span:first-child{
          width:120px;
          color:#000;
        }
        div {
          color:#bebebe;
          img {
            width:42px;
            height:42px;
            border-radius: 50%;
          }
        }
    }
  }
  .selectColor {
    cursor: pointer;
    color:#6597f7 !important;
  }

</style>